import React from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import Brightness5Icon from '@material-ui/icons/Brightness5';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import useAuth from '../../hooks/useAuth';
import { THEMES } from '../../constants';

const ThemeButton = () => {
  const { theme, changeTheme } = useAuth();

  const onChange = () => {
    changeTheme(theme === THEMES.LIGHT ? THEMES.DARK : THEMES.LIGHT);
  };

  return (
    <Tooltip title={`Temayı ${theme === THEMES.LIGHT ? 'geceye' : 'gündüze'} çevirmek için tıklayın`}>
      <IconButton
        color="inherit"
        onClick={onChange}
      >
        {
          theme === THEMES.LIGHT ? <Brightness5Icon /> : <Brightness4Icon />
        }
      </IconButton>
    </Tooltip>
  );
};

export default ThemeButton;
